var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    fill: "none",
    className: "social-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    clipPath: "url(#clip0_3601_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "currentColor",
    d: "M13.5 7.33a6.91 6.91 0 1 0 0 13.85 6.91 6.91 0 1 0 0-13.85Zm0 11.43a4.5 4.5 0 1 1 .02-9.02 4.5 4.5 0 0 1-.02 9.02Zm8.82-11.71a1.61 1.61 0 1 1-3.23 0 1.61 1.61 0 1 1 3.23 0Zm4.59 1.64c-.1-2.16-.6-4.08-2.19-5.66C23.15 1.45 21.23.96 19.07.85 16.84.72 10.16.72 7.93.85c-2.16.1-4.07.6-5.65 2.18C.69 4.6.2 6.52.09 8.68a172.4 172.4 0 0 0 0 11.14c.1 2.17.6 4.08 2.19 5.66 1.58 1.58 3.49 2.07 5.65 2.18 2.23.13 8.91.13 11.14 0 2.16-.1 4.08-.6 5.65-2.18 1.58-1.58 2.08-3.5 2.19-5.66.12-2.23.12-8.9 0-11.13ZM24.03 22.2a4.56 4.56 0 0 1-2.57 2.57c-1.78.7-6 .54-7.96.54s-6.18.16-7.95-.54a4.56 4.56 0 0 1-2.57-2.57c-.7-1.77-.54-5.99-.54-7.95 0-1.97-.16-6.2.54-7.96a4.56 4.56 0 0 1 2.57-2.57c1.77-.7 5.99-.54 7.95-.54 1.97 0 6.19-.16 7.96.54a4.56 4.56 0 0 1 2.57 2.57c.7 1.77.54 6 .54 7.96s.16 6.18-.54 7.95Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3601_1160"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .76h27v27H0z"
  })))));
};
export default SvgInstagram;